import { PaletteColors } from '@/Theme';

export const isPaletteColor = color => color in PaletteColors;
